<template lang="pug">
  WtEntityTable#MemberPointsTable(
    key="points-table"
    title=""
    has-large-title
    :fetch-action="fetchAction"
    :data="points"
    :pagination-object="pointsPagination"
    default-sort-field="pointsAwardedForDate"
    empty-message="No points awarded yet."
    :showEmptyMessage="pointsLoaded && _.isEmpty(points)"
    @fetchActionResponse="updateData"
  )
    BTableColumn(
      field="pointsAwardedForDate"
      label="Date"
      sortable
      v-slot="column"
    )
      | {{ date(column.row.pointsAwardedForDate, "DATE_FORMAT_SLASH").formatted }}
    BTableColumn(
      field="pointsAwardedFor"
      label="Category"
      sortable
      v-slot="column"
    )
      | {{ column.row.pointsAwardedFor }}
    BTableColumn(
      field="pointsAmount"
      label="Total Points Earned"
      sortable
      v-slot="column"
    )
      | {{ column.row.pointsAmount }}
    BTableColumn(
      v-if="$auth.user().isWtAdmin"
      label="Action"
      v-slot="column"
    )
      WtButton(
        is-text
        @click.native="deletePoints(column.row)"
        :loading="deletingPoints"
      )
        BIcon(icon="delete" type="is-danger")

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtButton from "@/components/WtButton/WtButton";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";

export default {
  name: "MemberPointsTable",

  components: {
    WtButton,
    WtTile,
    WtTitle,
    WtEntityTable
  },

  mixins: [dateUtilityMixin],

  props: {
    memberId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      points: [],
      pointsPagination: {},
      deletingPoints: false
    };
  },

  computed: {
    ...mapGetters("members", ["pointsLoaded"])
  },

  async mounted() {
    const response = await this.fetchPoints({ memberId: this.memberId });
    this.points = response.data;
    this.pointsPagination = response.pagination;
  },

  methods: {
    ...mapActions("members", ["fetchPoints"]),
    ...mapActions(["snackBar"]),

    async fetchAction(payload) {
      return await this.fetchPoints({
        memberId: this.memberId,
        ...payload
      });
    },

    updateData($event) {
      this.points = $event.data;
      this.pointsPagination = $event.pagination;
    },

    async deletePoints(pointsData) {
      this.deletingPoints = true;
      this.$buefy.dialog.confirm({
        title: `Delete Points`,
        confirmText: "Yes",
        cancelText: "No",
        type: "is-danger",
        message: `DELETING POINTS IS NOT REVERSIBLE! <br> Are you sure you want to delete these points? <br> Date: ${pointsData.pointsAwardedForDate} <br> For: ${pointsData.pointsAwardedFor} <br> Amount: ${pointsData.pointsAmount}`,
        closeOnConfirm: false,
        onConfirm: async (_, dialog) => {
          dialog.confirmText = "Processing ...";
          dialog.$refs.confirmButton.disabled = true;
          try {
            await this.axios.delete(
              `members/${this.memberId}/delete-points/${pointsData.id}`
            );
            this.snackBar({ message: "Points Deleted!" });
            this.snackBar({ message: "Refreshing Table!" });
            const fetchPointsResponse = await this.fetchPoints({
              memberId: this.memberId
            });
            this.points = fetchPointsResponse.data;
            this.pointsPagination = fetchPointsResponse.pagination;
          } catch (error) {
            this.deletingPoints = true;
            this.snackBar({ message: "Error!" });
          }

          this.deletingPoints = false;
          dialog.close();
        },
        onCancel: () => {
          this.deletingPoints = false;
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
#MemberPointsTable
  #points-table, #log-points-table
    /deep/ table
      table-layout: fixed
    /deep/ table .th-wrap
      width: 100%
    /deep/ table .th-wrap span:not(.icon)
      width: 100%
    /deep/ table thead tr th:nth-child(2)
      text-align: center
    /deep/ table tbody tr td:nth-child(2)
      text-align: center
    /deep/ table thead tr th:last-of-type
      text-align: end
    /deep/ table tbody tr td:last-of-type
      text-align: end
</style>
